export interface TbPanelSection {
  id: string;
  title: string;
  description: string;
  placeholderLabel: string;
  placeholderHint: string;
  featuresLeft: string[];
  featuresRight: string[];
  imagePosition: "left" | "right";
}

export interface TbWorkflowStep {
  title: string;
  text: string;
}

export const tbCustomerFeaturesLeft = [
  "StartPage",
  "Register/Login",
  "Multi Payment Options",
  "Schedule a Ride",
  "Ride Confirmation",
  "Referral Code Generation",
  "Ratings & Reviews",
  "Panic Alerts",
  "Push Notifications",
  "Ride Details",
];

export const tbCustomerFeaturesRight = [
  "Ride History",
  "User Profile Management",
  "Menu",
  "Social Logins",
  "Taxi Availability",
  "Emergency Contacts",
  "Coupon Code / Discount",
  "One Click Chat",
  "Add Location",
  "Settings & Options",
];

export const tbAdminFeaturesLeft = [
  "Authentication",
  "One Click Dashboard",
  "Push Notification",
  "Driver Management",
  "Category Management",
  "User Management",
  "Zone Management",
  "Tariff Management",
];

export const tbAdminFeaturesRight = [
  "Ride Management",
  "Vehicle Management",
  "Location Based Tracking",
  "Profile Management",
  "Offers & Discount Management",
  "Pay & Commission Management",
  "Email & SMS Campaign",
  "Insights & Report",
];

export const tbDriverFeaturesLeft = [
  "Driver Profile",
  "Dashboard",
  "Push Notification",
  "GPS Integration",
  "Request Accept",
  "Request Reject",
  "Vehicle Tracking System (GPS)",
  "Email & SMS Alerts",
];

export const tbDriverFeaturesRight = [
  "Automatic fare calculation",
  "Trip History",
  "Multi Language Support",
  "Contact Passengers",
  "Review management",
  "Transaction History",
  "Financial Information",
  "Insights and Report",
];

export const tbWorkflowSteps: TbWorkflowStep[] = [
  {
    title: "User Registration",
    text: "Passengers register or log in via social accounts, verify their profile, and set payment preferences before booking a ride.",
  },
  {
    title: "Ride Request",
    text: "Customers search for nearby taxis, select pickup and drop locations, choose payment mode, and confirm the ride request.",
  },
  {
    title: "Driver Dispatch",
    text: "The system notifies available drivers in the zone. Drivers accept or reject requests through the driver app in real time.",
  },
  {
    title: "Live Tracking",
    text: "GPS integration tracks the vehicle route. Passengers see live ETA, chat or call the driver, and receive push notifications.",
  },
  {
    title: "Ride Completion",
    text: "Automatic fare calculation runs at trip end. Payment is processed, receipts are generated, and both parties can rate the experience.",
  },
  {
    title: "Admin Oversight",
    text: "The admin panel monitors rides, earnings, commissions, drivers, vehicles, and zone-wise operations with insights and reports.",
  },
];

export const tbAdvantages = [
  "Build your own taxi booking app like Uber and Ola with a white-label Uber clone solution",
  "Customized taxi app development for customer, driver, and admin — earn from your own taxi business",
  "Real-time GPS tracking, route navigation, and location-based driver dispatch",
  "Multi payment options — cash, cards, UPI, Paytm, Google Pay, and wallet integration",
  "Schedule rides, panic alerts, emergency contacts, and one-click chat for passenger safety",
  "Automatic fare calculation with tariff and zone management from the admin panel",
  "Driver accept/reject workflow with earnings, trip history, and commission management",
  "Offers, coupons, referral codes, ratings, reviews, and push notification campaigns",
  "Fully integrated admin dashboard for users, drivers, vehicles, rides, and financial reports",
  "Top taxi booking app development company in Bangalore, India — device-friendly multi-platform apps",
];

export const tbPanels: TbPanelSection[] = [
  {
    id: "admin",
    title: "Taxi Booking App Admin Panel",
    description:
      "A fully-integrated and secured admin panel to manage all business aspects of the taxi booking application.",
    placeholderLabel: "Admin Dashboard",
    placeholderHint: "Bookings · Revenue · Driver management",
    featuresLeft: tbAdminFeaturesLeft,
    featuresRight: tbAdminFeaturesRight,
    imagePosition: "left",
  },
  {
    id: "driver",
    title: "Driver App Panel",
    description:
      "A real-time driver mobile app interface to manage ride requests, navigation, and payment workflows.",
    placeholderLabel: "Driver App",
    placeholderHint: "GPS · Accept/Reject · Trip history",
    featuresLeft: tbDriverFeaturesLeft,
    featuresRight: tbDriverFeaturesRight,
    imagePosition: "right",
  },
];
